export default "__VITE_ASSET__BjTuBPCw__"